<template>
    <v-dialog v-model="dialogShowStatus" hide-overlay max-width="80%">
        <v-app>
            <v-form ref="form" @submit.prevent="confirm">
                <v-card class="window-card">
                    <v-card-title>
                        <span class="md-title" style="color: #67ad5b">新增任务步骤</span>
                    </v-card-title>
                    <v-card-text>
                        <v-select v-model="formData.type" :items="tabType" item-text="label" item-value="value" label="类型" :rules="[v => !!v || '类型不能为空']"></v-select>
                        <DeviceMetaTab v-if="formData.type == 'device'" ref="device" :treeData="treeData" />
                        <ToolMetaTab v-if="formData.type == 'tool'" ref="tool" />
                        <RoleMetaTab v-if="formData.type == 'role'" ref="role" />
                        <SceneMetaTab v-if="formData.type == 'scene'" ref="scene" />
                        <SystemMetaTab v-if="formData.type == 'system'" ref="system" />
                        <v-text-field v-model="formData.stepTime" label="步骤时间 *" :rules="[v => !!v || '步骤时间不能为空']" hint="请使用整数类型，单位秒（s）"></v-text-field>
                        <md-field>
                            <label>步骤顺序</label>
                            <md-input v-model="formData.stepOrder" type="number"> </md-input>
                            <span class="md-helper-text">请使用阿拉伯数字</span>
                        </md-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" @click="handelConfirm">确 定</v-btn>
                        <v-btn color="success" @click="handleClose">关 闭</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-app>
    </v-dialog>
</template>
<script>
import { Tabs, NavTabsCard } from '@/components'
import DeviceMetaTab from './Tab/DeviceMetaTab'
import RoleMetaTab from './Tab/RoleMetaTab'
import SystemMetaTab from './Tab/SystemMetaTab'
import SceneMetaTab from './Tab/SceneMetaTab'
import ToolMetaTab from './Tab/ToolMetaTab'
import { extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'
import { tabType } from './TabType'
extend('required', required)

export default {
    props: {
        showExtDialog: {
            type: Boolean,
            default: false
        },
        treeData: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            dialogShowStatus: false,
            formData: {
                type: 'device'
            },
            tab: '',
            tabType
        }
    },
    watch: {
        showExtDialog(val) {
            this.dialogShowStatus = val
            this.formData = {
                type: 'device'
            }
        }
    },
    methods: {
        init(form) {
            let that = this;
            that.formData = JSON.parse(JSON.stringify(form))
            that.$nextTick(() => {
                that.$refs[that.formData.type].init(that.formData ?? {})
            })
        },
        tabChange(e) {
            this.tab = e
        },
        handleClose() {
            this.$emit('close', false)
        },
        handelConfirm() {
            return this.$refs.form.validate().then((res) => {
                if (res) {
                    const type = this.formData.type
                    const subObj = {
                        ...this.$refs[type].form,
                        ...this.formData
                    }
                    console.log("subObj---", subObj)
                    this.$emit('confirm', subObj)
                }
            })
        }
    },
    components: {
        Tabs,
        NavTabsCard,
        DeviceMetaTab,
        RoleMetaTab,
        SystemMetaTab,
        SceneMetaTab,
        ToolMetaTab
    }
}
</script>
<style>
.window-card {
    box-shadow: 0 0px 0px 0 rgb(0 0 0 / 14%) !important;
}
</style>